'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { AbstractImage } from '@mntn-dev/ui-utilities'
import { useState } from 'react'
import { Icon } from '../../../icon/icon.tsx'
import type { IconSize } from '../../../icon/types/core.ts'
import { LoadingSpinner } from '../../../loading/loading-spinner.tsx'
import { type CardScale, useCardContext } from '../../use-card.ts'

export type CardImageProps = {
  image: AbstractImage
  src?: string
  alt: string
  width?: number
  height?: number
  className?: string
}

export const cardImageSizeMap: Record<
  CardScale,
  { width: number; height: number }
> = {
  sm: { width: 64, height: 64 },
  md: { width: 160, height: 160 },
  lg: { width: 256, height: 256 },
}

const iconSizeMap: Record<CardScale, IconSize> = {
  sm: 'xl',
  md: '5xl',
  lg: '7xl',
}

export const CardImage = ({
  alt,
  className,
  height,
  image: Image,
  src,
  width,
}: CardImageProps) => {
  const [loading, setLoading] = useState<boolean>(true)
  const { scale = 'lg' } = useCardContext()
  return (
    <div
      className={cn(
        'overflow-hidden rounded-lg bg-gray-800 opacity-90 relative flex items-center justify-center shrink-0',
        className
      )}
      style={{
        height: cardImageSizeMap[scale].height,
        width: cardImageSizeMap[scale].width,
      }}
    >
      {src ? (
        <>
          <Image
            src={src}
            alt={alt}
            width={width ?? cardImageSizeMap[scale].width}
            height={height ?? cardImageSizeMap[scale].height}
            onLoad={() => setLoading(false)}
            className={cn('w-full h-full object-cover overflow-hidden', {
              invisible: loading,
            })}
          />
          {loading && (
            <div
              className={cn(
                'w-full h-full flex items-center justify-center absolute left-0 top-0'
              )}
            >
              <LoadingSpinner className="text-primary-blue h-12 w-12" />
            </div>
          )}
        </>
      ) : (
        <Icon
          name="VideoIcon"
          size={iconSizeMap[scale]}
          className="text-primary-blue"
        />
      )}
    </div>
  )
}
